import { render, staticRenderFns } from "./CardLastWinNumber.vue?vue&type=template&id=039f0d2e&lang=pug"
import script from "./CardLastWinNumber.vue?vue&type=script&lang=js"
export * from "./CardLastWinNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports